// Buying Qantas points directly costs about 2.67 cents each. Deals at or under this
// are a cheaper way to earn points than buying them outright.
export const BUY_POINTS_CENTS_PER_POINT = 2.666;
